<template>
  <div v-if="!isEditingAlert || !isMobile" class="step-wrapper">
    <div
      class="step"
      :class="{
        visited: isVisitedObj[1] || isEditingAlert,
        active: index === 1,
        disabled: isEditingAlert && (isApplyBtnDisabled || isSubmitBtnDisabled)
      }"
      @click="changeStep(1)"
    >
      <span :class="{ capitalized: !isMobile && !isLargeScreen }"
        >{{ title }} filter</span
      >
      <span><fa icon="chevron-right"></fa></span>
    </div>
    <div
      class="step"
      :class="{
        visited: isVisitedObj[2] || isEditingAlert,
        active: index === 2,
        disabled:
          (!isEditingAlert && !isVisitedObj[2] && index !== 2) ||
          (isEditingAlert && (isApplyBtnDisabled || isSubmitBtnDisabled))
      }"
      @click="changeStep(2)"
    >
      <span :class="{ capitalized: !isMobile && !isLargeScreen }"
        >{{ title }} trigger</span
      >
      <span><fa icon="chevron-right"></fa></span>
    </div>
    <div
      class="step"
      :class="{
        visited: isVisitedObj[3] || isEditingAlert,
        active: index === 3,
        disabled:
          (!isEditingAlert && !isVisitedObj[3] && index !== 3) ||
          (isEditingAlert && (isApplyBtnDisabled || isSubmitBtnDisabled))
      }"
      @click="changeStep(3)"
    >
      <span :class="{ capitalized: !isMobile && !isLargeScreen }"
        >{{ title }} notification</span
      >
      <span><fa icon="chevron-right"></fa></span>
    </div>
    <div
      class="step"
      :class="{
        visited: isVisitedObj[4] || isEditingAlert,
        active: index === 4,
        disabled:
          (!isEditingAlert && !isVisitedObj[4] && index !== 4) ||
          (isEditingAlert && (isApplyBtnDisabled || isSubmitBtnDisabled))
      }"
      @click="changeStep(4)"
    >
      <span :class="{ capitalized: !isMobile && !isLargeScreen }">{{
        titleName
      }}</span>
      <span><fa icon="chevron-right"></fa></span>
    </div>
  </div>

  <div v-else class="tab-step-wrapper">
    <div
      class="tab-step"
      :class="{
        visited: isVisitedObj[1] || isEditingAlert,
        active: index === 1,
        disabled: isEditingAlert && (isApplyBtnDisabled || isSubmitBtnDisabled)
      }"
      @click="changeStep(1)"
    >
      <span>Filter</span>
    </div>
    <div
      class="tab-step"
      :class="{
        visited: isVisitedObj[2] || isEditingAlert,
        active: index === 2,
        disabled:
          (!isEditingAlert && !isVisitedObj[2] && index !== 2) ||
          (isEditingAlert && (isApplyBtnDisabled || isSubmitBtnDisabled))
      }"
      @click="changeStep(2)"
    >
      <span>Trigger</span>
    </div>
    <div
      class="tab-step"
      :class="{
        visited: isVisitedObj[3] || isEditingAlert,
        active: index === 3,
        disabled:
          (!isEditingAlert && !isVisitedObj[3] && index !== 3) ||
          (isEditingAlert && (isApplyBtnDisabled || isSubmitBtnDisabled))
      }"
      @click="changeStep(3)"
    >
      <span>Notification</span>
    </div>
    <div
      class="tab-step"
      :class="{
        visited: isVisitedObj[4] || isEditingAlert,
        active: index === 4,
        disabled:
          (!isEditingAlert && !isVisitedObj[4] && index !== 4) ||
          (isEditingAlert && (isApplyBtnDisabled || isSubmitBtnDisabled))
      }"
      @click="changeStep(4)"
    >
      <span>Name</span>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
export default {
  name: 'Steps',
  props: ['index', 'isVisitedObj', 'isApplyBtnDisabled', 'isSubmitBtnDisabled'],
  computed: {
    ...mapGetters(['isMobile', 'isLargeScreen']),
    ...mapState('alertsSuspiciousTrafficStore', ['isEditingAlert']),
    title() {
      if (!this.isMobile && !this.isLargeScreen) {
        return '';
      } else {
        return this.isEditingAlert ? 'Edit' : 'Define';
      }
    },
    titleName() {
      if (!this.isMobile && !this.isLargeScreen) {
        return 'name';
      } else {
        return this.isEditingAlert ? 'Edit name' : 'Name alert';
      }
    }
  },
  methods: {
    changeStep(stepId) {
      this.$emit('changeStep', stepId);
    }
  }
};
</script>

<style lang="scss" scoped>
.step-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 1.5rem 1rem;
  background-color: $background-grey;
}

.step {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  height: 3rem;
  line-height: 3rem;
  margin-bottom: 1.5rem;
  padding: 0 1rem;
  background-color: #fff;
  color: $icon-grey;
  font-weight: 600;
}

.visited {
  cursor: pointer;
}

.disabled {
  color: $disabled-grey;
  cursor: not-allowed;
  pointer-events: none;
}

.active {
  border: 1px solid $text-light-blue;
  color: $text-light-blue;
}

.tab-step-wrapper {
  display: flex;
  flex-direction: row;
  height: 100%;
  background-color: $background-grey;
}

.tab-step {
  flex: 1;
  height: 3rem;
  line-height: 3rem;
  margin: 0 1rem;
  color: $icon-grey;
  font-weight: 600;
  text-align: center;

  &.active {
    border: none;
    border-bottom: 2px solid $text-light-blue;
  }
}

.capitalized {
  text-transform: capitalize;
}
</style>
